/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * Icons
 */
import icons from './icons.js';

import './index.toolbar';

import EditAIHelper from './edit.ai.helper';
import SaveAIHelper from './save.ai.helper';

registerBlockType( 'momothemes/momo-ai-helper-pro', {
    title: __( 'AI Helper', 'momoacg' ),
    description: __( 'AI Helper', 'momoacg' ),
    icon: icons.circle,
    keywords: [
        __( 'Helper', 'momoacg' ),
        __( 'AI', 'momoacg' ),
        __( 'MoMo', 'momoacg' ),
        __( 'ACG', 'momoacg' ),
        __( 'AI Helper', 'momoacg' ),
    ],
    /**
     * @see ./edit.js
     */
    edit: EditAIHelper,

    /**
     * @see ./save.js
     */
    save: SaveAIHelper,
} );
